<template>
  <div class="ts-login-portal">
    <header>
      <h4>Welcome back</h4>
      <br />
      <div class="ts-login-portal-register">
        <p>New to TalentSensus?</p>
        <div id="mc_embed_signup">
          <form
            action="https://talentsensus.us19.list-manage.com/subscribe/post?u=85c8ab25d7cfb91fc8c817b3a&amp;id=86d2a03b8d"
            method="post"
            id="mc-embedded-subscribe-form"
            name="mc-embedded-subscribe-form"
            class="validate"
            target="_blank"
            novalidate
          >
            <div id="mc_embed_signup_scroll">
              <div id="mce-responses" class="clear">
                <div
                  class="response"
                  id="mce-error-response"
                  style="display: none"
                ></div>
                <div
                  class="response"
                  id="mce-success-response"
                  style="display: none"
                ></div>
              </div>
              <div style="position: absolute; left: -5000px" aria-hidden="true">
                <input
                  type="text"
                  name="b_85c8ab25d7cfb91fc8c817b3a_86d2a03b8d"
                  tabindex="-1"
                  value=""
                />
              </div>
              <div class="clear">
                <input
                  type="submit"
                  value="Register"
                  name="Register"
                  id="mc-embedded-subscribe"
                  class=""
                />
              </div>
            </div>
          </form>
        </div>
      </div>
      <br />
    </header>

    <el-form @submit.native.prevent>
      <el-form-item :required="true">
        <el-input placeholder="Subdomain" v-model="workspaceUrl" class="mb20">
          <template slot="append">.talentsensus.com</template>
        </el-input>
      </el-form-item>

      <p v-if="showWorkspaceNotFoundError" class="small error">
        The specified workspace could not be found. Please check and try again.
      </p>

      <button
        class="ts-btn ts-btn-secondary ts-btn-small center"
        v-on:click="verifySubdomain()"
      >
        Grab my workspace
      </button>
      <!-- <p class="small"><br />Don't remember your Workspace URL? <a href="">Click here</a></p> -->
    </el-form>
    <div class="ts-login-portal-register-agency">
      <div class="helper-info">
        <p>
          Please sign in to your workspace by entering in your company
          subdomain. This could be something like "nike.talentsensus.com" or
          "coca-cola.talentsensus.com".
          <br />
          If you have not been issued with a subdomain, which will be included
          in your introduction email, please register&nbsp;
        </p>
        <div id="mc_embed_signup">
          <form
            action="https://talentsensus.us19.list-manage.com/subscribe/post?u=85c8ab25d7cfb91fc8c817b3a&amp;id=86d2a03b8d"
            method="post"
            id="mc-embedded-subscribe-form"
            name="mc-embedded-subscribe-form"
            class="validate"
            target="_blank"
            novalidate
          >
            <div id="mc_embed_signup_scroll">
              <div id="mce-responses" class="clear">
                <div
                  class="response"
                  id="mce-error-response"
                  style="display: none"
                ></div>
                <div
                  class="response"
                  id="mce-success-response"
                  style="display: none"
                ></div>
              </div>
              <div style="position: absolute; left: -5000px" aria-hidden="true">
                <input
                  type="text"
                  name="b_85c8ab25d7cfb91fc8c817b3a_86d2a03b8d"
                  tabindex="-1"
                  value=""
                />
              </div>
              <div class="clear">
                <input
                  style="padding-left: 0; padding-right: 0"
                  type="submit"
                  value="here"
                  name="here"
                  id="mc-embedded-subscribe"
                  class=""
                />.
              </div>
            </div>
          </form>
        </div>
      </div>
      <img src="../../../assets/img/icons/person.png" />
    </div>
  </div>
</template>

<script>
export default {
  name: "login",
  data() {
    return {
      workspaceUrl: "",
      showWorkspaceNotFoundError: false,
      loading: false,
    };
  },
  methods: {
    verifySubdomain() {
      this.loading = true;

      this.$store
        .dispatch("organisation/get", this.workspaceUrl)
        .then((res) => {
          const redirectUrl = process.env.VUE_APP_PRIVATE_BASE_URL.replace('{SUBDOMAIN}', res.subDomain);
          window.location = redirectUrl;
        })
        .catch(() => {
          this.showWorkspaceNotFoundError = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss"></style>
